import React, { useState } from 'react';
import WifiTetheringOutlinedIcon from '@mui/icons-material/WifiTetheringOutlined';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import { formatDateText } from '../grid/dates';

// New UI for Integrations (docs/ui_redesign/14-screen-concepts.md, "Integrations", option A): one card per connection
// with labelled Test connection, Edit and Delete. The same rows, fields and handlers as the Classic grid, in the grid's
// saved sort order.
export function sortRows(rows, sortModel) {
	const list = [...(rows || [])];
	const s = sortModel && sortModel[0];
	if (!s || !s.field) return list;
	const dir = s.sort === 'desc' ? -1 : 1;
	const val = r => { const v = r[s.field]; return v == null ? '' : v; };
	return list.sort((a, b) => {
		const x = val(a); const y = val(b);
		if (typeof x === 'boolean' || typeof y === 'boolean') return (Number(x) - Number(y)) * dir;
		return String(x).localeCompare(String(y), undefined, { numeric: true }) * dir;
	});
}

const when = v => (v ? formatDateText(new Date(v).toLocaleString('en-US')) : '—'); // MM/DD/YYYY, no midnight time (R15)

export default function IntegrationCards({ rows, sortModel, onTest, onEdit, onDelete }) {
	const list = sortRows(rows, sortModel);
	// R17: the card shows the test's result (the Online / Offline the test sets), not only the toast.
	const [tests, setTests] = useState({});
	const test = (row, id) => {
		setTests(t => ({ ...t, [id]: 'running' }));
		Promise.resolve(onTest({ row, id })).finally(() => setTests(t => ({ ...t, [id]: 'done' })));
	};
	if (!list.length) {
		return <div className="apw2-int-empty" role="status"><b>No integrations yet</b><span>Use Link Integration to connect an ERP, an email inbox or an SFTP drop.</span></div>;
	}
	return (
		<ul className="apw2-int-cards" aria-label="Integrations">
			{list.map(row => (
				<li key={row.adtechIntegrationId ?? row.rowId} className="apw2-int-card">
					<div className="apw2-int-h">
						<h2>{row.adtechIntegrationName}</h2>
						<span className={'apw2-pill ' + (row.isActive ? 't-ok' : 't-bad')}>{row.isActive ? 'Online' : 'Offline'}</span>
					</div>
					<dl className="apw2-int-kv">
						<dt>Type</dt><dd>{row.integrationTypeName || '—'}</dd>
						<dt>Integration</dt><dd>{row.integrationName || '—'}</dd>
						<dt>Last updated</dt><dd>{when(row.lastUpdated)}</dd>
					</dl>
					{tests[row.adtechIntegrationId ?? row.rowId] ? (
						<p className={'apw2-int-test' + (tests[row.adtechIntegrationId ?? row.rowId] === 'running' ? '' : row.isActive ? ' ok' : ' bad')} role="status">
							{tests[row.adtechIntegrationId ?? row.rowId] === 'running' ? 'Testing the connection…' : row.isActive ? 'Connection verified just now' : 'The connection test failed just now'}
						</p>
					) : null}
					<div className="apw2-int-acts">
						<button type="button" className="apw2-rowbtn" disabled={tests[row.adtechIntegrationId ?? row.rowId] === 'running'} onClick={() => test(row, row.adtechIntegrationId ?? row.rowId)}><WifiTetheringOutlinedIcon fontSize="inherit" />Test connection</button>
						<button type="button" className="apw2-rowbtn" onClick={() => onEdit(row)}><EditIcon fontSize="inherit" />Edit</button>
						<span className="apw2-grow" />
						<button type="button" className="apw2-rowbtn danger" onClick={() => onDelete(row)}><DeleteIcon fontSize="inherit" />Delete</button>
					</div>
				</li>
			))}
		</ul>
	);
}
